module.exports = __webpack_public_path__ + "static/media/ic_twitter.bd25dda4.svg";